module.exports = require('./helpers/bundle-url').getBundleURL('i5qVm') + "logo-dark.eefe0b7f.svg";